module.exports = __webpack_public_path__ + "static/media/campus_23.85a608d8.png";